import { InteractionHandler } from "../Interactions";
import { InputEventTrigger, convertToNumber3, } from "flavr-common";
import { EnableOrbitControlsRotationMessage } from "../../../messages/rendering/MeshMessages";
import { ModelHoverMessage, ModelTouchMessage, ModelTouchState } from "../../../messages/interaction/InteractionMessages";
import { Vector3 } from "flavr-math";
const TOUCH_MOVE_THRESHOLD = 0.001;
const tempHitPoint = new Vector3();
/**
 * Used by the Ui3DRenderable to forward hover, click and drag events to the UIs underlying HTML elements. This is
 * automatically created by the Ui3DRenderable and shouldn't be instantiated manually.
 */
export class UI3DInteractionHandler extends InteractionHandler {
    constructor(interactionModule) {
        super(InputEventTrigger.typestatic, [InputEventTrigger.typestatic], [], []);
        this.interactionModule = interactionModule;
        this.selectedModels = new Map();
        this.rotationDisabled = false;
    }
    getBehaviorDescription() {
        return "";
    }
    onSelect(params, uid, controller, hitPoint) {
        if (!InputEventTrigger.is(params))
            return;
        this.selectedModels.set(controller.uid, {
            modelUid: uid,
            lastHitPoint: new Vector3().fromArray(hitPoint),
            pressed: false,
            touched: false
        });
    }
    onDeselect(params, uid, controller, hitPoint) {
        if (!InputEventTrigger.is(params))
            return;
        const model = this.selectedModels.get(controller.uid);
        if (model === undefined)
            return;
        const hitPointVec = tempHitPoint.fromArray(hitPoint);
        this.onTouchEnd(params, model, uid, controller, hitPointVec);
        this.selectedModels.delete(controller.uid);
        this.checkOrbitRotation(true, params);
    }
    onSelectButtonPress(params, {}, controller) {
        if (!InputEventTrigger.is(params))
            return;
        const model = this.selectedModels.get(controller.uid);
        if (model === undefined)
            return;
        model.pressed = true;
        this.checkOrbitRotation(false, params);
    }
    onSelectButtonRelease(params, uid, controller, hitPoint) {
        if (!InputEventTrigger.is(params))
            return;
        this.checkOrbitRotation(true, params);
        const model = this.selectedModels.get(controller.uid);
        if (model === undefined)
            return;
        const hitPointVec = tempHitPoint.fromArray(hitPoint);
        this.onTouchEnd(params, model, uid, controller, hitPointVec);
        model.pressed = false;
    }
    onControllerMove(params, uid, controller, hitPoint) {
        if (!InputEventTrigger.is(params))
            return;
        const model = this.selectedModels.get(controller.uid);
        if (model === undefined)
            return;
        if (params.sendHover) {
            this.connection.send(new ModelHoverMessage(uid, controller.uid, hitPoint));
        }
        if (params.sendTouch) {
            const hitPointVec = tempHitPoint.fromArray(hitPoint);
            if (model.pressed) {
                this.onTouchStartOrMove(model, uid, controller, hitPointVec);
            }
            else if (model.touched) {
                this.onTouchEnd(params, model, uid, controller, hitPointVec);
            }
        }
    }
    onTouchStartOrMove(model, uid, controller, hitPoint) {
        const state = model.touched ? ModelTouchState.Move : ModelTouchState.Start;
        if (!model.touched) {
            model.touched = true;
        }
        else {
            if (model.lastHitPoint.manhattanDistanceTo(hitPoint) < TOUCH_MOVE_THRESHOLD)
                return;
        }
        this.connection.send(new ModelTouchMessage(uid, controller.uid, state, convertToNumber3(model.lastHitPoint), convertToNumber3(hitPoint)));
        model.lastHitPoint.copy(hitPoint);
    }
    onTouchEnd(params, model, uid, controller, hitPoint) {
        if (!model.touched)
            return;
        model.touched = false;
        if (!params.sendTouch)
            return;
        this.connection.send(new ModelTouchMessage(uid, controller.uid, ModelTouchState.End, convertToNumber3(model.lastHitPoint), convertToNumber3(hitPoint)));
    }
    checkOrbitRotation(enabled, params) {
        if (params.disableOrbitRotation) {
            if (this.rotationDisabled !== enabled)
                return;
            this.rotationDisabled = !enabled;
        }
        else {
            if (!this.rotationDisabled || !enabled) {
                return;
            }
        }
        this.connection.send(new EnableOrbitControlsRotationMessage(enabled));
    }
}
